import {MerchantResolvers} from '../../../generated';

const merchant: MerchantResolvers = {
  website: () => 'http://example.com',
  phone_number: () => '+12345678901',
};

export default merchant;
